// extracted by mini-css-extract-plugin
export default {"container":"DisplayBadge_container__qY6g0","display":"DisplayBadge_display__3obw-","close":"DisplayBadge_close__pNeTc","wait":"DisplayBadge_wait__Hzhyg"};